import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AddAreaModal } from './AddAreaModal';
import { useAreaStore } from '../../store/areaStore';
import { useState } from 'react';
import { SearchIcon } from 'lucide-react';

export const AreaToolbar = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { searchQuery, setSearchQuery } = useAreaStore();

  const handleSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  }, [setSearchQuery]);

  const handleClearFilter = useCallback(() => {
    setSearchQuery('');
  }, [setSearchQuery]);

  return (
    <>
      <div className="flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
        {/* Search Input */}
        <div className="w-full md:max-w-lg">
          <div className="relative">
            <input 
              type="text" 
              value={searchQuery}
              onChange={handleSearch}
              placeholder={t('areas.searchPlaceholder')} 
              className="input input-bordered w-full pl-10" 
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <SearchIcon className="h-5 w-5 text-gray-400" />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex gap-2 md:gap-3">
          {searchQuery && (
            <button 
              className="btn btn-ghost flex-1 md:flex-none"
              onClick={handleClearFilter}
            >
              {t('areas.clearFilter')}
            </button>
          )}
          <button 
            className="btn btn-primary flex-1 md:flex-none"
            onClick={() => setIsModalOpen(true)}
          >
            {t('areas.addNew')}
          </button>
        </div>
      </div>

      <AddAreaModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}; 